/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import {
  CheckIcon,
  Flex,
  LinkInactiveIcon,
  Text,
  useClipboard,
} from '@getgo/chameleon-chakra-ui';

import { Button } from '../Buttons/Button';
import { Link } from '../Link/Link';
import { Divider } from '../Divider/Divider';
import { getCurrentUrl } from '../../services/NavigatorService';
import {
  installGoogleChromeUrl,
  installMicrosoftEdgeUrl,
} from '../../services/UrlService';

interface Props {
  heading: string;
  troubleshooting: string;
}

const messages = defineMessages({
  troubleshootingCopyLinkButton: {
    id: 'error.troubleshooting.breakouts.unsupported.browser.copyLinkButton',
  },
  troubleshootingCopyLinkButtonConfirm: {
    id: 'error.troubleshooting.breakouts.unsupported.browser.copyLinkButtonConfirm',
  },
  troubleshootingQuestion: {
    id: 'error.troubleshooting.breakouts.unsupported.browser.question',
  },
  troubleshootingDownloadChrome: {
    id: 'error.troubleshooting.breakouts.unsupported.browser.downloadChrome',
  },
  troubleshootingDownloadEdge: {
    id: 'error.troubleshooting.breakouts.unsupported.browser.downloadEdge',
  },
});

export const UnsupportedLayout: React.FC<Props> = (props) => {
  const currentUrl = getCurrentUrl();
  const { hasCopied, onCopy } = useClipboard(currentUrl);
  const { formatMessage: f } = useIntl();
  return (
    <Flex
      direction='column'
      justifyContent='center'
      alignItems='center'
      id='unsupported'
      pb='10vh'
    >
      <Text as='h1' maxWidth='600px' textAlign='center'>
        {props.heading}
      </Text>
      <Flex direction='column' alignItems='center' mt='7vh'>
        <Text>{props.troubleshooting}</Text>
        <Flex direction='row' alignItems='center' mt='1vh'>
          <Text
            border='solid 1px white'
            borderRadius='3px'
            padding='11px'
            maxWidth='30vw'
            whiteSpace='nowrap'
            overflow='hidden'
            textOverflow='ellipsis'
          >
            {currentUrl}
          </Text>
          <Button
            onClick={onCopy}
            leftIcon={
              hasCopied ? (
                <CheckIcon width='24px' height='24px' />
              ) : (
                <LinkInactiveIcon width='24px' height='24px' />
              )
            }
            minWidth='10vw'
            ml='1vh'
          >
            {hasCopied
              ? f(messages.troubleshootingCopyLinkButtonConfirm)
              : f(messages.troubleshootingCopyLinkButton)}
          </Button>
        </Flex>
      </Flex>
      <Flex mt='8vh' direction='column' alignItems='center'>
        <Text>{f(messages.troubleshootingQuestion)}</Text>
        <Flex>
          <Link
            textDecoration='underline'
            mr='1vh'
            href={installGoogleChromeUrl}
            isExternal={true}
          >
            {f(messages.troubleshootingDownloadChrome)}
          </Link>
          <Divider />
          <Link
            textDecoration='underline'
            ml='1vh'
            href={installMicrosoftEdgeUrl}
            isExternal={true}
          >
            {f(messages.troubleshootingDownloadEdge)}
          </Link>
        </Flex>
      </Flex>
    </Flex>
  );
};
